import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagBG(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAYUExURd0qFf39/QGZcff39wOfdfPz8wSjeAWme3eP0pIAAADkSURBVDjL7YwxbsMwDEV5hAa6QCDwADEI7YEgeA4gaO8gWGsn5fr9pJ04DWqjS7O0DyD1ST6bDvu80QsEccMwiBO5dX1vJXIivFiLTnPHybIT5w4Q5OFmWwuDbXBTYZcfCNkokkMouZScgzz0cKGiwABqBJ3Wni9k322z/OF3hes+HxD6ta2LthR6n4VppU29P+d3mnqbNmizsM1owljriJq7Vqop1fv2TOkZGPU+jN8IX4HAKSZmZLYYNS0bDGfy0bPHzAga2fsYI8foAfsj4RDZBnX0plI0DcOR/D4vEf75S3wCXObnBmEuj90AAAAASUVORK5CYII=",
    alt: "BG"
  }, props));
}